import '../common/extensions/dom_ready'
import '../common/extensions/progress_bar'
import '../common/extensions/jquery_form'
import '../common/extensions/bootstrap_modal'
import '../common/extensions/toggle_prefix'
import '../common/extensions/toggle_presence'
import '../common/extensions/checkbox_toggle'
import '../common/extensions/ajax_helpers'
import '../common/extensions/global_behaviors'
import { installConfirmModalBridge } from '../lib/confirm_modal_bridge'
import '../common/extensions/window'
import '../common/extensions/survey_iframe_helpers'
import '../common/extensions/local_draft_manager'
import '../common/extensions/gtm_prevent_default_fix'
import '../common/extensions/inherits_from'

installConfirmModalBridge()
